import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Alert,
} from '@mui/material';
import { FC, useState, useContext } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import PaymentInformationForm from '@features/employerOnboarding/components/PaymentInformationForm/PaymentInformationForm';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { authContext } from '@staffedupusa/shared-components';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';

type ChargeforBoostProps = {
  handleClose: () => void;
  selectedCompanyId?: string | number;
  numberOfWeeks?: number;
  locationBoost?: boolean
  socialBoost?: boolean
};

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_KEY);

const ChargeforBoost: FC<ChargeforBoostProps> = ({ handleClose, selectedCompanyId, locationBoost, socialBoost, numberOfWeeks }) => {
  const [errorText, setErrorText] = useState<string>('');
  const { authData } = useContext(authContext);
  return (
    <Dialog
      open
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>
        <IconButton sx={{ position: 'absolute', top: 5, right: 5 }} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
        <br />
        <RocketLaunchOutlinedIcon
          sx={{
            fontSize: 60,
            color: 'primary.main',
            margin: 'auto !important',
          }}
        />
        <br />
        <Typography variant="h4" >
          Add a Payment Method to Boost Your Job
        </Typography>
      </DialogTitle>
      <DialogContent>
        {errorText && <Alert sx={{ margin: "10px 0" }} severity="error">{errorText}</Alert>}
        <Typography color='gray' textAlign='center' variant="body1" mb={3}>
          To proceed with boosting your job, please add a payment method. Your card will be securely saved for future boosts and seamless transactions.
        </Typography>
        <Elements stripe={stripePromise}>
          <PaymentInformationForm
            handleClose={handleClose}
            boostCharge={true}
            socialBoost={socialBoost ? true : false}
            locationBoost={locationBoost ? true : false}
            selectedCompanyId={selectedCompanyId}
            numberOfWeeks={numberOfWeeks}
            enterpriseCall={!!authData?.user?.enterprise}
          />
        </Elements>
      </DialogContent>
    </Dialog>
  );
};

export default ChargeforBoost;
